import React from "react";
import { Button } from "reactstrap";

export default function Digilocker(props) {
  return (
    <div className="digilocker-main">
      <div className="header">
        <p className="text-capitalize">Complete your KYC</p>
      </div>
      <div className="body">
        <div className="text">
          DigiLocker is a key initiative under Digital India, the Government of
          India's flagship program. For DigiLocker verification, please ensure
          your aadhaar is linked to a mobile number.
        </div>
        <div className="btn-div">
          <Button 
            color="secondary"
            onClick={props.redirectToDigio}
            disabled={!props?.isDigioEnabled}
          >
            Continue with DigiLocker
          </Button>
          {!props?.isDigioEnabled && 
            <p className="mt-2 font-size-tiny text-danger">DigiLocker is currently under maintenance.</p>
          }
          <div className="text mt-2">
          In order to complete your KYC, we need an Address Proof and a Pan Record. Please provide your consent for the same in the next page.
          </div>
        </div>
        <div className="divider-div">
          <div className="divider" />
          <p>or</p>
          <div className="divider" />
        </div>
        <div className="text">
          Alternatively, you can also continue to upload documents with us to
          complete your KYC process.
          <br />
          <br />
        </div>
        <div className={!props?.isDigioEnabled
              ? "manually-btn-digio-disabled"
              : "manually-btn"}
             onClick={props.uploadManually}
        >
          Upload documents manually
        </div>
      </div>
    </div>
  );
}
